export const INTEGRATION_CATEGORIES = [
  'all',
  'communication',
  'automation',
  'ai',
  'developer',
  'system',
];

export const INTEGRATION_ORDER = [
  'webhook',
  'direct_chat',
  'external_dashboard',
  'click_to_call',
  'mobile_app',
  'openai',
  'doc_signature',
  'forms',
];

export const INTEGRATION_META = {
  webhook: {
    category: 'developer',
    hasToggle: false,
    icon: 'webhook',
    iconClass: 'text-[#3B82F6] bg-[#EFF6FF]',
    manage: { type: 'route', name: 'settings_integrations_webhook' },
  },
  direct_chat: {
    category: 'communication',
    hasToggle: false,
    icon: 'forum',
    iconClass: 'text-[#EF4444] bg-red-50',
    manage: { type: 'route', name: 'settings_integrations_direct_chat' },
  },
  external_dashboard: {
    category: 'system',
    hasToggle: false,
    icon: 'dashboard_customize',
    iconClass: 'text-neutral-500 bg-neutral-50',
    manage: { type: 'route', name: 'settings_integrations_external_dashboard' },
  },
  click_to_call: {
    category: 'communication',
    hasToggle: true,
    icon: 'call',
    iconClass: 'text-[#EF4444] bg-red-50',
    manage: { type: 'modal', key: 'click2call' },
  },
  mobile_app: {
    category: 'developer',
    hasToggle: true,
    icon: 'mobile_chat',
    iconClass: 'text-[#3B82F6] bg-[#EFF6FF]',
    manage: { type: 'route', name: 'settings_integrations_mobile_app' },
    manageNeedsHook: true,
  },
  openai: {
    category: 'ai',
    hasToggle: true,
    logo: 'openai-chatgpt.svg',
    iconClass: 'bg-yellow-50',
    manage: { type: 'modal', key: 'openai' },
    manageNeedsHook: true,
  },
  doc_signature: {
    category: 'developer',
    hasToggle: true,
    icon: 'signature',
    iconClass: 'text-[#3B82F6] bg-[#EFF6FF]',
    manage: { type: 'modal', key: 'doc_signature' },
  },
  forms: {
    category: 'communication',
    hasToggle: true,
    logo: 'forms.svg',
    logoFill: true,
    iconClass: 'bg-[#EEF2FF]',
    manage: null,
  },
  google_translate: {
    category: 'ai',
    hasToggle: false,
    icon: 'translate',
    iconClass: 'text-[#F59E0B] bg-yellow-50',
    manage: null,
  },
};

export const INTEGRATION_PERMISSION_NAMES = {
  openai: 'ChatGPT',
  webhook: 'Webhooks',
  click_to_call: 'Click2Call',
  doc_signature: 'IntegrationDocal',
  forms: 'IntegrationForms',
};

export const WEBHOOK_EVENT_GROUPS = [
  {
    key: 'conversations',
    events: [
      'conversation_created',
      'conversation_updated',
      'conversation_status_changed',
    ],
  },
  {
    key: 'messages',
    events: [
      'message_created_customer',
      'message_created_agent',
      'message_created_bot',
      'message_updated',
    ],
  },
  {
    key: 'contacts',
    events: [
      'contact_created',
      'contact_updated',
      'contact_deleted',
      'block_list.contact_blocked',
      'block_list.contact_unblocked',
    ],
  },
  {
    key: 'system',
    events: [
      'webwidget_triggered',
      'csat_survey_submitted',
      'ticket_resolved',
      'agent_status_changed',
      'signing_link_updated',
      'form_link_generated',
      'form_submitted',
    ],
  },
];

export const filterIntegrations = (
  list,
  { search = '', category = 'all' } = {}
) => {
  const query = (search || '').trim().toLowerCase();
  return list.filter(item => {
    const meta = INTEGRATION_META[item.id];
    if (category !== 'all' && meta?.category !== category) {
      return false;
    }
    if (!query) {
      return true;
    }
    const name = (item.name || '').toLowerCase();
    const description = (item.description || '').toLowerCase();
    return name.includes(query) || description.includes(query);
  });
};

export const orderIntegrations = list => {
  const ordered = [];
  const rest = [];
  list.forEach(item => {
    if (INTEGRATION_ORDER.includes(item.id)) {
      ordered.push(item);
    } else {
      rest.push(item);
    }
  });
  ordered.sort(
    (a, b) => INTEGRATION_ORDER.indexOf(a.id) - INTEGRATION_ORDER.indexOf(b.id)
  );
  return [...ordered, ...rest];
};
